<template>
  <div class="orderlist bj order-container">
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="from1"
      @Refresh="Refresh"
      @search="search"
      @selectAllChange="cityChange"
      @changeAmt="changeAmt"
    >
      <template v-slot:left v-if="totalObj.is_show && totalObj.is_show == 1">
        <span class="mr10"> 订单总金额：{{ totalObj.order_amt }}元</span>
        <span class="mr10"> 总件数：{{ totalObj.total_qty }}件</span>
        <span class="mr10"> 总吨数：{{ totalObj.tonnage_total }}吨</span>
        <span> 总下单人数：{{ totalObj.member_total }}人</span>
      </template>
      <template v-slot:right>
        <el-button
          v-if="totalObj.is_show_export && totalObj.is_show_export == 1"
          type="warning"
          :disabled="!tableData.length || disabledExport"
          @click="onHandleExport"
          icon="el-icon-upload2"
          >导出</el-button
        >
      </template>
    </Filtersearch>

    <div class="auto-table-flex">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="index" width="100px" align="center" label="序号">
        </el-table-column>
        <el-table-column
          prop="logistic_business"
          align="center"
          label="集配中心"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.logistic_business">{{
              $empty.empty(scope.row.logistic_business.name)
            }}</span>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column prop="order_no" align="center" label="订单编号">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.order_no) }}
          </template>
        </el-table-column>
        <el-table-column prop="trade_no" align="center" label="微信交易单号"
          ><template slot-scope="scope">
            {{ scope.row.trade_no || "—" }}
          </template></el-table-column
        >
        <el-table-column prop="create_time" align="center" label="订单创建时间">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.create_time) }}
          </template>
        </el-table-column>
        <el-table-column prop="pay_at" align="center" label="客户名称">
          <template slot-scope="scope" v-if="scope.row.member">
            {{ $empty.empty(scope.row.member.fullname) }}
          </template>
        </el-table-column>
        <el-table-column prop="pay_at" align="center" label="客户电话">
          <template slot-scope="scope" v-if="scope.row.member">
            {{ $empty.empty(scope.row.member.mobile) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="pay_app_id"
          align="center"
          label="商户号"
        ></el-table-column>
        <el-table-column prop="pay_at" align="center" label="支付时间">
          <template slot-scope="scope">
            {{ $empty.time(scope.row.pay_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="订单状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 1">待付款</span>
            <span v-else-if="scope.row.state == 2">已付款</span>
            <span v-else-if="scope.row.state == 3">已取消</span>
            <span v-else-if="scope.row.state == 4 && scope.row.supply == 2"
              >订货中</span
            >
            <span v-else-if="scope.row.state == 4">已生成供货单</span>
            <span v-else-if="scope.row.state == 5">已完成</span>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          align="center"
          label="订单金额"
          v-if="!is_tmp_user"
        >
          <template slot-scope="scope">
            {{ $empty.empty(tool.format_money(scope.row.order_amt)) }}
          </template>
        </el-table-column>

        <!-- 商品改版新增 start -->
        <el-table-column
          prop="ori_order_amt"
          align="center"
          label="支付总金额"
          v-if="!is_tmp_user"
        >
          <template slot-scope="scope">
            {{
              (scope.row.ori_order_amt &&
                (scope.row.ori_order_amt / 100)?.toFixed(2)) ||
              "-"
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="real_order_diff_amt"
          align="center"
          label="退差价总金额"
          min-width="100"
          v-if="!is_tmp_user"
        >
          <template slot-scope="scope">
            {{
              (scope.row.real_order_diff_amt &&
                (scope.row.real_order_diff_amt / 100)?.toFixed(2)) ||
              "-"
            }}
          </template>
        </el-table-column>
        <!-- 商品改版新增 end -->

        <el-table-column prop="name" align="center" label="城市仓">
          <template
            slot-scope="scope"
            v-if="
              scope.row.store_delivery && scope.row.store_delivery.logistics
            "
          >
            {{ $empty.empty(scope.row.store_delivery.logistics.name) }}
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="自提点">
          <template slot-scope="scope" v-if="scope.row.store_delivery">
            {{ $empty.empty(scope.row.store_delivery.name) }}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <router-link
              v-if="!is_tmp_user"
              :to="{ name: 'orderDetail', query: { id: scope.row.id } }"
              class="main-color pointer text-none"
              >查看详情
            </router-link>
            <el-button
              type="text"
              v-if="scope.row.is_payment_order"
              @click="onHandlePay(scope.row)"
              >确认已付款</el-button
            >

            <el-button
              type="text"
              v-if="
                is_change_order && scope.row.supply == 0 && scope.row.state == 2
              "
              @click="oncancel(scope.row)"
              >取消订单</el-button
            >
            <el-button
              type="text"
              v-if="
                is_change_order && scope.row.supply == 0 && scope.row.state == 2
              "
              @click="onChange(scope.row)"
              >变更自提点</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="from1.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <cancelOfOrder
      ref="cancelOfOrder"
      @cancelOfOrder="cancelOfOrder"
    ></cancelOfOrder>
    <ChangeSelfPickupPoint
      ref="ChangeSelfPickupPoint"
      @cityConfirm="cityConfirm"
    ></ChangeSelfPickupPoint>
  </div>
</template>
<script>
import { Loading } from "element-ui";
// import { BASE } from "@/api";
// import { getOrderExport } from "@/api/export/index";
// import { downLoadFlowBlob } from "@/utils/tools/base";
// import { getOffsetDate } from "@/utils/tools/date";
import { postLogisticsOrderListExport } from "@/api/export/center";
import utilsTool from "@/utils/tools/tool";
import cloneDeep from "lodash/cloneDeep";
import { postOrderConfirmPayment } from "@/api/general/order";
import cancelOfOrder from "./modules/orderlist-dialog/cancelOfOrder.vue";
import ChangeSelfPickupPoint from "./modules/orderlist-dialog/ChangeSelfPickupPoint.vue";
import Filtersearch from "@/components/Filtersearch.vue";
import { postRegionalManagerSelectList } from "@/api/general/manager.js";
export default {
  name: "orderlist",
  components: {
    cancelOfOrder,
    ChangeSelfPickupPoint,
    Filtersearch,
  },
  data() {
    return {
      Filtersearchlist: [
        {
          type: "input",
          name: "订单编号",
          clearable: true,
          model: "order_no",
          placeholder: "请输入订单编号",
        },
        {
          type: "datetimerange",
          name: "支付时间",
          clearable: true,
          model: "pay_at",
          startmodel: "pay_start",
          endmodel: "pay_end",
          startplaceholder: "开始时间",
          endplaceholder: "结束时间",
          format: "MM-dd HH:mm",
        },
        {
          type: "select",
          name: "订单状态",
          clearable: true,
          model: "state",
          multiple: true,
          placeholder: "请选择订单状态",
          label: "label",
          value: "value",
          selectoption: [
            {
              label: "待付款",
              value: "1",
            },
            {
              label: "已付款",
              value: "2",
            },
            {
              label: "已取消",
              value: "3",
            },
            {
              label: "已完成",
              value: "5",
            },
          ],
        },
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          filterable: true,
          model: "logistic_business_id",
          placeholder: "请选择集配中心",
          selectoptionname: "businessList",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "selectAllChange",
          name: "城市仓",
          clearable: true,
          filterable: true,
          multiple: true,
          model: "logistics_id",
          placeholder: "请选择城市仓",
          selectoptionname: "logisticsList",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "select",
          name: "自提点",
          clearable: true,
          filterable: true,
          multiple: true,
          model: "delivery_id",
          placeholder: "请选择自提点",
          label: "name",
          value: "id",
          selectoptionname: "selflist",
          selectoption: [],
        },
        {
          type: "select",
          name: "供货状态",
          clearable: true,
          model: "supply",
          placeholder: "请选择供货状态",
          label: "label",
          value: "value",
          selectoption: [
            { label: "全部", value: "" },
            { label: "未订货", value: "-1" },
            { label: "订货中", value: "1" },
            { label: "已生成供货单", value: "2" },
          ],
        },
        {
          type: "datetimerange",
          name: "结算时间",
          clearable: true,
          model: "wx_settlement_time",
          startplaceholder: "结算时间起",
          endplaceholder: "结算时间止",
        },
        {
          type: "datetimerange",
          name: "创建时间",
          clearable: true,
          model: "create_at",
          startmodel: "create_start",
          endmodel: "create_end",
          startplaceholder: "创建时间起",
          endplaceholder: "创建时间止",
        },
        {
          type: "select",
          name: "结算状态",
          clearable: true,
          filterable: true,
          model: "wx_settlement_status",
          placeholder: "请选择结算状态",
          label: "label",
          value: "value",
          selectoption: [
            { label: "全部", value: "" },
            { label: "未结算", value: "0" },
            { label: "已结算", value: "1" },
          ],
        },
        {
          type: "input",
          name: "微信交易单号",
          clearable: true,
          model: "trade_no",
          placeholder: "请输入微信交易单号",
        },
        {
          type: "zfTime",
          name: "支付金额",
          clearable: true,
          minmodel: "order_amt_min",
          maxmodel: "order_amt_max",
          placeholder: "请输入",
        },
        {
          type: "input",
          name: "客户名称",
          clearable: true,
          model: "member_name",
          placeholder: "请输入客户名称",
        },
        {
          type: "input",
          name: "客户电话",
          clearable: true,
          model: "mobile",
          placeholder: "请输入客户电话",
        },
        {
          type: "input",
          name: "商户号",
          clearable: true,
          model: "pay_app_id",
          placeholder: "请输入商户号",
        },
                {
          type: "select",
          name: "支付方式",
          clearable: true,
          model: "pay_type",
          placeholder: "请选择支付方式",
          label: "label",
          value: "value",
          selectoption: [
            { label: "全部", value: "" },
            { label: "微信支付", value: "1" },
            { label: "大客户支付", value: "2" },
            { label: "活动金支付", value: "3" },
          ],
        },
         {
          type: "select",
          name: "区域经理",
          clearable: true,
          filterable: true,
          model: "regional_manager_id",
          placeholder: "请选择区域经理",
          selectoptionname: "managerList",
          label: "fullname",
          value: "id",
          selectoption: [],
        },
         {
          type: "checkbox",
          placeholder: "不含已取消",
          clearable: true,
          filterable: true,
          model: "cancelState",
        
        },
      ],
      //列表新建页面初始参数
      loading: true,
      is_tmp_user: false,
      utilsTool,
      pay_at: "",
      create_at: [],
      orderAmtStart: "",
      orderAmtEnd: "",
      is_change_order: "",
      from: {
        regional_manager_id: "",
        order_no: "",
        pay_at: [],
        pay_start: "",
        pay_end: "",
        state: [],
        logistic_business_id: "",
        logistics_id: "",
        delivery_id: "",
        supply: "",
        wx_settlement_time: "",
        create_at: [],
        create_start: "",
        create_end: "",
        wx_settlement_status: "",
        trade_no: "",
        order_amt_min: "",
        order_amt_max: "",
        member_name: "",
        mobile: "",
        pay_app_id: "",
        pay_type:'',
         cancelState:1,
        page: 1,
        pageSize: 10,
      },
      from1: {
         regional_manager_id: "",
        order_no: "",
        pay_at: [],
        pay_start: "",
        pay_end: "",
        state: [],
        logistic_business_id: "",
        logistics_id: "",
        delivery_id: "",
        supply: "",
        wx_settlement_time: "",
        create_at: [],
        create_start: "",
        create_end: "",
        wx_settlement_status: "",
        trade_no: "",
        order_amt_min: "",
        order_amt_max: "",
        member_name: "",
        mobile: "",
        pay_app_id: "",
        pay_type:'',
         cancelState:1,
        page: 1,
        pageSize: 10,
      },
      tableData: [],
      currentPage: 1,
      total: 0,
      done: 2, // 已付款状态
      //列表页面不同功能参数

      options: [],
      storelist: [],
      selflist: [],
      logistics_id: "",
      list: [],
      list1: [],
      disabledExport: false, // 导出禁用
      totalObj: {}, // 汇总数据
    };
  },
  computed: {
    // 全选的勾选状态 true、false
    serviceSelectedAll() {
      return this.from1.logistics_id.length === this.storelist.length;
    },
  },
  created() {
    if (window.location.href.indexOf("?") > -1) {
      /** 历史丢参问题，修复 start */
      const url = this.tool.getUrl(window.location.href);
      // 无效的值
      const invalid = ["", null, undefined, "null", "undefined"];
      url.page = (invalid.includes(url.page) && 1) || url.page;
      url.pageSize = (invalid.includes(url.pageSize) && 10) || url.pageSize;
      /** 历史丢参问题，修复 end */
      this.from = url;
      this.from1 = url;
      this.currentPage = Number(this.from1.page);
      this.from1.pageSize = Number(this.from1.pageSize);
      this.from.logistics_id = this.from.logistics_id
        ? this.from.logistics_id
        : "";
         this.from.cancelState = this.from.cancelState
        ? Number(this.from.cancelState)
        : 1;
      this.from.logistic_business_id = this.from.logistic_business_id
        ? Number(this.from.logistic_business_id)
        : "";
      this.from1.logistics_id = this.from1.logistics_id
        ? this.from1.logistics_id
        : "";
      this.from1.logistic_business_id = this.from1.logistic_business_id
        ? Number(this.from.logistic_business_id)
        : "";
      this.from1.regional_manager_id = this.from1.regional_manager_id
        ? Number(this.from.regional_manager_id)
        : "";

      if (this.from1.create_start) {
        this.from1.create_at = [this.from1.create_start, this.from1.create_end];
      } else {
        this.from1.create_at = [];
      }
      if (this.from1.pay_start) {
        this.from1.pay_at = [this.from1.pay_start, this.from1.pay_end];
      } else {
        let date = new Date();
        this.from1.pay_at = [
          this.tool.timestampToTimemin(new Date()),
          this.tool.timestampToTimemin(new Date()),
        ];
        this.from1.pay_start = this.tool.timestampToTimemin(new Date());
        this.from1.pay_end = this.tool.timestampToTimemin(new Date());
        this.from.pay_start = this.tool.timestampToTimemin(new Date());
        this.from.pay_end = this.tool.timestampToTimemin(new Date());
      }
      // 特殊处理支付金额 参数
      // let money = url.order_amt.join(",");
      // this.orderAmtStart = url.order_amt[0] ? url.order_amt[0] : "";
      // this.orderAmtEnd = url.order_amt[1] ? url.order_amt[1] : "";
      // this.from1.order_amt = money;
      // this.from.order_amt = money;
      console.log(this.pay_at, this.from1, this.from);
    } else {
      // 增加默认逻辑 超过14点 开始结束时间为今天到明天12点 反之 开始结束时间为昨天到今天12点
      let now = new Date();
      const hour = now.getHours();
      let start, end;
      if (hour >= 14) {
        // 今天14:00:00 到 明天14:00:00
        start = new Date(now);
        start.setHours(14, 0, 0, 0);

        end = new Date(now);
        end.setDate(end.getDate() + 1);
        end.setHours(14, 0, 0, 0);
      } else {
        // 昨天14:00:00 到 今天14:00:00
        start = new Date(now);
        start.setDate(start.getDate() - 1);
        start.setHours(14, 0, 0, 0);

        end = new Date(now);
        end.setHours(14, 0, 0, 0);
      }
      this.from1.pay_at = [
        this.tool.timestampToTimemin(start),
        this.tool.timestampToTimemin(end),
      ];
      this.from.pay_at = [
        this.tool.timestampToTimemin(start),
        this.tool.timestampToTimemin(end),
      ];
      this.from1.pay_start = this.tool.timestampToTimemin(start);
      this.from1.pay_end = this.tool.timestampToTimemin(end);
      this.from.pay_start = this.tool.timestampToTimemin(start);
      this.from.pay_end = this.tool.timestampToTimemin(end);
      this.from1.state = []; // 默认订单状态已完成
      this.from.state = []; // 默认订单状态已完成
    }
    if (this.from1.logistics_id) {
      this.getListData(this.from1.logistics_id);
    }
    this.hqlist();
    this.getAjaxTotal();
    this.citylist();
    this.getBusinessList();
    this.postAjaxRegionalManagerSelectList(); // 区域经理下拉
  },
  methods: {
     // 区域经理下拉
    async postAjaxRegionalManagerSelectList() {
      try {
        const res = await postRegionalManagerSelectList();
        console.log(res, "res==");
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "managerList"
          ) {
            el.selectoption = [ { id: "", fullname: "全部" },...res.data];
          }
        });
      } catch (error) {
        console.log(error, "postRegionalManagerSelectList");
      }
    },
    onChange(e) {
      console.log("变更自提点");
      this.$refs.ChangeSelfPickupPoint.hqinfo(e);
    },
    oncancel(e) {
      this.$refs.cancelOfOrder.hqinfo(e);
      console.log("取消订单");
    },
    cityConfirm() {
      this.hqlist();
    },
    cancelOfOrder() {
      this.hqlist();
    },
    /**
     * 金额发生改变
     */
    changeAmt(e) {
      if (
        e.order_amt_min &&
        e.order_amt_max &&
        Number(e.order_amt_min) > Number(e.order_amt_max)
      ) {
        // this.orderAmtStart = "";
        // this.orderAmtEnd = "";
        this.$message.warning("起始金额不得大于截止金额");
        this.$refs.Filtersearchref.from.order_amt_min = "";
        this.$refs.Filtersearchref.from.order_amt_max = "";
        this.from1.order_amt_min = "";
        this.from1.order_amt_max = "";
        this.from.order_amt_min = "";
        this.from.order_amt_max = "";
      } else {
        // this.from1.order_amt = `${this.orderAmtStart},${this.orderAmtEnd}`;
      }
    },
    /**
     * 确认已付款
     */
    async onHandlePay(row) {
      const params = {
        order_id: row.id,
      };
      try {
        await postOrderConfirmPayment(params);
        // 接口成功后，不重新请求，直接修改状态
        const index = this.tableData.findIndex((item) => item.id == row.id);
        this.tableData[index].is_payment_order = false;
        this.tableData[index].state = this.done;
      } catch (err) {
        console.log("ajax postOrderConfirmPayment err", err);
      } finally {
      }
    },
    // 集配中心列表
    getBusinessList() {
      this.$api.general.businessList().then((res) => {
        this.options = res.data;
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "businessList"
          ) {
            el.selectoption = [{ id: "", name: "全部" }, ...res.data];
          }
        });
      });
    },
    // 自提点下拉
    getListData(val) {
      this.$api.general
        .deliveryList({
          logistics_id: val, //必须填写
          page: 1,
          pageSize: 1000,
        })
        .then((res) => {
          console.log(res, "获取数据");
          this.selflist = res.data.data;
          this.Filtersearchlist.forEach((el) => {
            if (
              el.type == "select" &&
              el.selectoptionname &&
              el.selectoptionname == "selflist"
            ) {
              el.selectoption = [...res.data.data];
            }
          });
        });
    },
    /**
     * 导出数据（下载中心）
     */
    async onHandleExport() {
      this.changeAmt(this.from1);
      this.from = this.tool.DeepCopy({}, this.from1);
      /** 触发导出事件 */
      const {
        order_amt_min,
        order_amt_max,
        member_name,
        mobile,
        order_no,
        trade_no,
        pay_start,
        pay_end,
        wx_settlement_time,
        wx_settlement_status,
        state,
        logistic_business_id,
        delivery_id,
        logistics_id,
        create_start,
        create_end,
        supply,
        pay_app_id,
        pay_type,
        regional_manager_id,
         cancelState
      } = this.from;
      const params = {
        order_amt_min,
        order_amt_max,
        member_name,
        mobile,
        order_no,
        trade_no,
        pay_start,
        pay_end,
        state,
        delivery_id,
        wx_settlement_time,
        wx_settlement_status,
        logistics_id,
        logistic_business_id,
        create_start,
        create_end,
        supply,
        pay_app_id,
        pay_type,
        regional_manager_id,
         cancelState
      };
      this.getAjaxOrderExport(params);
    },
    /**
     * 导出excel数据
     */
    async getAjaxOrderExport(params) {
      /** 新导出逻辑 */
      this.disabledExport = true;
      const { username } = JSON.parse(sessionStorage.getItem("userInfo"));
      try {
        const query = {
          ...params,
          token: sessionStorage.getItem("token"),
          user_name: username,
        };
        delete query.page;
        delete query.pageSize;
        await postLogisticsOrderListExport(query);
        this.goExportCenter();
      } catch (err) {
        console.log("ajax postLogisticsOrderListExport err", err);
        this.disabledExport = false;
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    // 城市仓列表
    citylist() {
      this.$api.general
        .logisticsList({
          name: "",
          page: 1,
          pageSize: 1000,
        })
        .then((res) => {
          console.log(res, "获取数据");
          this.storelist = res.data;
          this.Filtersearchlist.forEach((el) => {
            if (
              el.type == "selectAllChange" &&
              el.selectoptionname &&
              el.selectoptionname == "logisticsList"
            ) {
              el.selectoption = [...res.data];
            }
          });
        });
    },
    onServiceSelectedAll() {
      if (this.serviceSelectedAll) {
        // 取消全选
        this.from1.logistics_id = [];
      } else {
        this.from1.logistics_id = this.storelist.map((item) => item.id);
      }
    },
    cityChange(val) {
      this.Filtersearchlist.forEach((el) => {
        if (
          el.type == "select" &&
          el.selectoptionname &&
          el.selectoptionname == "selflist"
        ) {
          el.selectoption = [];
        }
      });
      this.$refs.Filtersearchref.from.delivery_id = "";
      this.getListData(val);
    },
    handleSelectionChange(val) {
      // this.multipleSelection = val;
      console.log(val);
    },
    toggleSelection() {
      this.$nextTick(() => {
        this.$refs.multipleTable.toggleAllSelection();
      });
    },
    listHandle() {
      this.$confirm("确定要生成供货单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          let load = Loading.service({ fullscreen: false });
          console.log(load);
          this.tool.debounce(() => {
            this.from = this.tool.DeepCopy({}, this.from1);
            if (
              (Array.isArray(this.from.delivery_id) &&
                this.from.delivery_id.length == 0) ||
              !this.from.delivery_id
            ) {
              delete this.from.delivery_id;
            }
            if (
              (Array.isArray(this.from.logistics_id) &&
                this.from.logistics_id.length == 0) ||
              !this.from.logistics_id
            ) {
              delete this.from.logistics_id;
            }
            this.$api.general
              .addOrder(this.from)
              .then((res) => {
                this.tool.message("已生成", "success");
                load.close();
                this.Refresh();
              })
              .catch((error) => {
                load.close();
              });
          });
        })
        .catch(() => {});
    },
    search(e) {
      this.from1 = e;
      this.from = e;
      this.changeAmt(this.from1);
      this.from.page = 1;
      this.from1.page = 1;
      this.currentPage = 1;
      this.from = this.tool.DeepCopy({}, this.from1);
      if (
        (Array.isArray(this.from.delivery_id) &&
          this.from.delivery_id.length == 0) ||
        !this.from.delivery_id
      ) {
        delete this.from.delivery_id;
      }
      if (
        (Array.isArray(this.from.logistics_id) &&
          this.from.logistics_id.length == 0) ||
        !this.from.logistics_id
      ) {
        delete this.from.logistics_id;
      }
      this.redirectPath();
      this.hqlist();
      this.getAjaxTotal();
    },
    changestore(e) {
      // console.log(e);
      this.ruleForm.name = JSON.parse(e).name;
      this.ruleForm.store_id = JSON.parse(e).id;
    },
    addclick() {
      console.log("新增");

      this.ruleForm = {
        business_type_code: "logistics", //集配：logistics 自提点：delivery
        store_id: "",
        name: "",
        itemdata: "",
        username: "",
        password: "",
      };

      this.centerDialogVisible = true;
      this.title = "新增中心账号";
    },
    tianku() {
      console.log(this.ruleForm);
      this.centerDialogVisible = false;
      this.$api.login.addbusiness(this.ruleForm).then((res) => {
        this.$message({
          type: "success",
          message: "添加成功",
        });
        this.Refresh();
      });
    },
    /**
     * 搜索参数添加到路径
     */
    redirectPath() {
      let tmpData = { ...this.from };
      // 修复支付金额路径报错
      //    tmpData.order_amt = tmpData.order_amt.split(",");
      this.tool.getResult(tmpData, window.location.href);
    },
    Refresh() {
      // 增加默认逻辑 超过14点 开始结束时间为今天到明天12点 反之 开始结束时间为昨天到今天12点
      let now = new Date();
      const hour = now.getHours();
      let start, end;
      if (hour >= 14) {
        // 今天14:00:00 到 明天14:00:00
        start = new Date(now);
        start.setHours(14, 0, 0, 0);

        end = new Date(now);
        end.setDate(end.getDate() + 1);
        end.setHours(14, 0, 0, 0);
      } else {
        // 昨天14:00:00 到 今天14:00:00
        start = new Date(now);
        start.setDate(start.getDate() - 1);
        start.setHours(14, 0, 0, 0);

        end = new Date(now);
        end.setHours(14, 0, 0, 0);
      }

      this.from = {
        regional_manager_id: "",
        order_amt_min: "",
        order_amt_max: "",
        member_name: "",
        mobile: "",
        order_no: "",
        trade_no: "",
        wx_settlement_time: "",
        wx_settlement_status: "",
        logistic_business_id: "",
        pay_at: [
          this.tool.timestampToTimemin(start),
          this.tool.timestampToTimemin(end),
        ],
        pay_start: this.tool.timestampToTimemin(start),
        pay_end: this.tool.timestampToTimemin(end),
        logistics_id: "",
        delivery_id: "",
        state: [],
        supply: "",
        create_at: [],
        create_start: "",
        create_end: "",
        pay_app_id: "",
        pay_type:'',
          cancelState:1,
        page: 1,
        pageSize: 10,
      };
      this.from1 = {
          cancelState:1,
        regional_manager_id: "",
        order_amt_min: "",
        order_amt_max: "",
        member_name: "",
        mobile: "",
        order_no: "",
        trade_no: "",
        logistic_business_id: "",
        pay_at: [
          this.tool.timestampToTimemin(start),
          this.tool.timestampToTimemin(end),
        ],
        pay_start: this.tool.timestampToTimemin(start),
        pay_end: this.tool.timestampToTimemin(end),
        wx_settlement_time: "",
        wx_settlement_status: "",
        logistics_id: "",
        delivery_id: "",
        state: [],
        supply: "",
        create_at: [],
        create_start: "",
        create_end: "",
        pay_app_id: "",
        pay_type:'',
        page: 1,
        pageSize: 10,
      };
      this.from1.state = [];
      this.from.state = [];
      this.currentPage = 1;
      this.redirectPath();
      console.log(this.from);
      this.hqlist();
      this.getAjaxTotal();
    },
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.from.pageSize = val;
      this.from1.pageSize = val;
      this.redirectPath();
      this.hqlist();
    },
    handleCurrentChange(val) {
      this.from.page = val;
      this.from1.page = val;
      this.currentPage = val;
      this.redirectPath();
      this.hqlist();
    },
    payChange(val) {
      console.log(val);
      if (val) {
        this.from1.pay_start = val[0];
        this.from1.pay_end = val[1];
      } else {
        this.from1.pay_start = "";
        this.from1.pay_end = "";
      }
    },
    create_atChange(val) {
      console.log(val);
      if (val) {
        this.from1.create_start = val[0];
        this.from1.create_end = val[1];
      } else {
        this.from1.create_start = "";
        this.from1.create_end = "";
      }
    },
    handleEdit(index, row) {
      this.$confirm(
        row.status === 1
          ? "确定要禁用该中心账号吗？"
          : "确定要启用该中心账户吗？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.login
            .businessstatus({
              id: row.id,
              status: row.status === 1 ? 0 : 1,
            })
            .then((res) => {
              console.log(res, "禁用或者启用");
              this.$message({
                type: "success",
                message: row.status === 1 ? "禁用成功" : "启用成功",
              });
              this.hqlist();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: row.status === 1 ? "取消禁用" : "取消启用",
          });
        });
    },

    selectda(index, row) {
      this.title = "修改中心账号";
      this.ruleForm.business_type_code = row.business_type_code;
      console.log(this.ruleForm, this.list, this.list);
      this.centerDialogVisible = true;
    },
    // 订单汇总
    async getAjaxTotal() {
      let form = cloneDeep(this.from);
      form.wx_settlement_time = Array.isArray(form.wx_settlement_time)
        ? form.wx_settlement_time.join(",")
        : form.wx_settlement_time;
      console.log(form);
      try {
        const res = await this.$api.general.orderTotal(form);
        console.log(res, "获取数据");
        this.totalObj = res.data;
      } catch (error) {
        console.log(error, "orderTotal");
      }
    },
    hqlist() {
      this.loading = true;
      let form = cloneDeep(this.from);
      form.wx_settlement_time = Array.isArray(form.wx_settlement_time)
        ? form.wx_settlement_time.join(",")
        : form.wx_settlement_time;
      console.log(form);
      this.$api.general.orderList(form).then((res) => {
        console.log(res, "获取数据");
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.is_change_order = res.data.is_change_order;
        this.is_tmp_user = res.data.is_tmp_user;
        this.loading = false;
      });
    },
    // seletlist() {
    //   this.$api.login.unusedall().then((res) => {
    //     console.log(res, "获取所有可配置的自提点");
    //     this.list1 = res.data;
    //   });
    //   this.$api.login.logisticsunusedall().then((res) => {
    //     console.log(res, "获取所有可配置的城市仓");

    //     this.list = res.data;
    //   });
    // },
  },
};
</script>
<style lang="scss">
.order-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;

  .checked-box {
    padding: 13px 15px;
  }

  .order-wrapper {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    background: #ffffff;
    padding: 10px 15px;

    .inputs {
      margin-right: 10px;
      margin-bottom: 10px;
    }

    .multiple-select {
      width: 250px;
    }
    .multiple-select-long {
      width: 320px;
      .el-select__input {
        height: auto;
      }
    }
  }

  .top {
    display: flex;
    align-items: center;
    .span {
      width: 100px;
    }
    &:nth-of-type(1),
    &:nth-of-type(4),
    &:nth-of-type(5) {
      margin-left: 15px;
    }
  }
  .mid {
    height: 36px;
    line-height: 36px;
  }
  .title {
    background: #ffffff;
    padding-top: 10px;
    padding-left: 15px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    .inputs {
      display: flex;
      align-items: center;
    }
    .seach {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;

      .multiple-select {
        width: 250px;
      }
    }

    .bjsearch {
      background: #333333;
      border-color: #333333;
    }
  }

  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    // background-color: #000;
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .contents {
    padding-left: 55px;
    padding-right: 55px;
    padding-top: 23px;

    box-sizing: border-box;

    .titlname {
      font-size: 17px;
      color: #21c2ac;
      margin-bottom: 25px;
    }

    .imgs {
      display: flex;

      .imglist {
        width: 165px;
        height: 123px;
        border: 1px dashed #a4adc5;
        padding: 14px 8px;
        text-align: center;
        border-radius: 7px;
        box-sizing: border-box;
        margin-right: 16px;

        .div {
          margin-top: 20px;
          padding-bottom: 20px;
        }

        // img{
        //     width: 100%;
        //     height: 100%;
        // }
      }
    }

    .disply {
      display: flex;
      margin-bottom: 22px;
    }

    .mr {
      margin-right: 31px;
    }

    .iteminput {
      display: flex;
      align-items: center;

      .wen {
        width: 77px;
        margin-right: 24px;
        color: #000;
        font-size: 14px;
        text-align: right;
      }

      .el-input {
        width: 302px;
      }
    }
  }

  .colors {
    color: #fa884c;
  }

  .times {
    margin-right: 8px;
  }

  // .el-picker-panel {
  //   left: 1245px !important;
  // }
}
</style>
